import React from 'react';
import { Input } from '../Input';

interface DurationFieldsProps {
  daysOn?: number;
  daysOff?: number;
  onChange: (key: 'days_on' | 'days_off', value: number) => void;
}

export const DurationFields: React.FC<DurationFieldsProps> = ({
  daysOn,
  daysOff,
  onChange,
}) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        <Input
          label="Days On"
          value={daysOn || ''}
          onChange={(value) => onChange('days_on', Number(value))}
          type="number"
          min={0}
          tooltip="Number of consecutive days to take the dosage"
        />
      </div>
      <div className="flex-1">
        <Input
          label="Days Off"
          value={daysOff || ''}
          onChange={(value) => onChange('days_off', Number(value))}
          type="number"
          min={0}
          tooltip="Number of days to rest between active periods"
        />
      </div>
    </div>
  );
};